import React, { useState} from "react";
import StateDescriptionPanel from "./StateDescriptionPanel";
import CommentType from "../../js/models/CommentType";
import {deserialize} from "../../js/utils/javascript-serializer";

import "./CommentForm.css";
import "./Comment.css";

export default function CommentForm({ commentInfo }) {

  const [visState, setVisState] = useState(false);
  const [visForm, setVisForm] = useState(false);
  const [visImage, setVisImage] = useState(false);
  const [visDescription, setVisDescription] = useState(false);

  let {state, form, element, details, text, comment_type, element_text, image} = commentInfo;
  let selectData = JSON.parse(details);
  let textData = JSON.parse(text);
  let encodedState = {};
  let encodedForm = {};
  let encodedElemText = "";

  console.log(image);

  try {
    encodedState = deserialize(state);
  } catch (error) {
    console.log(error);
    console.warn("Не удалось прочитать состояние!");
  }

  try{
    encodedForm = deserialize(form);
  } catch (error) {
    console.log(error);
    console.warn("Не удалось прочитать форму!");
  }

  if(element_text){
    try{
      encodedElemText = deserialize(element_text);
    } catch (error) {
      console.log(error);
      console.warn("Не удалось прочитать текст элемента!");
    }
  }
  

  try{
    encodedForm = deserialize(form);
  } catch (error) {
    console.log(error);
    console.warn("Не удалось прочитать форму!");
  }

  let firstSubform;
  let currentSubForm = CommentType[comment_type].subform.variants[element].subform;
  let defaultSubformProps = {
    form: currentSubForm,
    selectData: selectData,
    inputData: textData,
    deepArray: [-1, -1]
  }

    if(currentSubForm.type === "select"){
      defaultSubformProps.deepArray[0] += 1;
      firstSubform = <SelectForm {...defaultSubformProps}/>;
    }
    else if(currentSubForm.type === "text") {
      defaultSubformProps.deepArray[1] += 1;
      firstSubform = <InputForm {...defaultSubformProps}/>;
    }
    else {
      console.warn("Found unexpected subform type: " + currentSubForm.type);
    }
    
  // <option value="wrong-text">Текст не имеет смысла</option>
  return (
    <div className="report-comment-panel">
      <fieldset className="form-group" disabled={true}>
        
        <div htmlFor="commentType">Тип комментария</div>
        <select id="commentType" className="form-control" value={CommentType[comment_type].fullName}>
          <option>{CommentType[comment_type].fullName}</option>
        </select>
        <div htmlFor="commentType">Тип элемента</div>
        <select id="commentType" className="form-control" value={CommentType[comment_type].fullName}>
          <option>{CommentType[comment_type].subform.variants[element].fullName}</option>
        </select>
        {element_text ? 
          <><div htmlFor="mainTextarea">Текст элемента</div>
          <textarea id="mainTextarea" className="edit-textarea form-control" defaultValue={encodedElemText} /></>
         : false}

        {firstSubform}

        {image ? <div className="state-description">
          <h4 onClick={() => setVisImage(!visImage)}>Скриншот игры {!visImage ? "(показать)" : "(скрыть)"}</h4>
            <div className={"state-description-content state-description-content_vis_" + visImage}>
              <hr />
              <img src={image} alt="Скриншот игры"></img>
            </div>
        </div> : false}
      
        <div className="state-description">
          <h4 onClick={() => setVisDescription(!visDescription)}>Информация об игровой сессии {!visDescription && encodedState ? "(показать)" : "(скрыть)"}</h4>
          { (encodedState) &&
            <div className={"state-description-content state-description-content_vis_" + visDescription}>
              <hr />
              {<StateDescriptionPanel state={encodedState} mode={2} />}
            </div>
          }
        </div>
        {/* <div className="state-description">
          <h4 onClick={() => setVisState(!visState)}>Информация об состоянии {!visState && encodedState ? "(показать)" : "(скрыть)"}</h4>
          { (encodedState) &&
            <div className={"state-description-content state-description-content_vis_" + visState}>
              <hr />
              {JSON.stringify(encodedState, undefined, 2)}
            </div>
          }
        </div> */}

        {/* {encodedForm ? <div className="state-description">
          <h4 onClick={() => setVisForm(!visForm)}>Информация о форме {!visForm && encodedForm ? "(показать)" : "(скрыть)"}</h4>
          { (encodedForm) &&
            <div className={"state-description-content state-description-content_vis_" + visForm}>
              <hr />
              {JSON.stringify(encodedForm, undefined, 2)}
            </div>
          }
        </div> : false} */}
        
      </fieldset>
    </div>
  );
}

function SelectForm(props){
  let {form, selectData, inputData, deepArray} = props;

  let currentKey = selectData[deepArray[0]];
  let variants = form.variants;

  let subformType = "";
  if(!variants[currentKey]){
    return <></>;
  }

  let newArr = [];
    
  if(variants[currentKey].subform){
    subformType = variants[currentKey].subform.type;
    if(subformType === "select"){
      newArr = [deepArray[0] + 1, deepArray[1]];
    } else if(subformType === "text"){
      newArr = [deepArray[0], deepArray[1] + 1];
    }
  }

  let formProps = {
    form: variants[currentKey].subform,
    selectData,
    inputData,
    deepArray: newArr
  }

  return <>
    <div htmlFor="mainTextarea">{form.fullName}</div>
    <select id={"selectForm" + deepArray[0]} className="form-control">
      { <option>{variants[currentKey].fullName}</option>}
    </select>
    {
      subformType ?
      subformType === "select" ? <SelectForm {...formProps}/> : 
      subformType === "text" ? <InputForm {...formProps}/> : false
      : false
    }

  </>
}

function InputForm(props){
  let {form, selectData, inputData, deepArray} = props;

  const currentText = inputData[deepArray[1]];
  if(form.subform){
    let subformType = form.subform.type;
    if(subformType === "select"){
        deepArray[0] += 1;
    }
    else if(subformType === "text"){
        deepArray[1] += 1;
    }
  }

  let formProps = {
    form: form.subform,
    selectData,
    inputData,
    deepArray
  }

  return <>
    <div htmlFor="mainTextarea">Сообщение пользователя</div>
    <textarea id={"mainTextarea" + deepArray[1]} className="edit-textarea form-control" defaultValue={currentText} />
    {form.subform ?
       form.subform.type === "select" ? <SelectForm {...formProps}/> : 
       form.subform.type === "text" ? <InputForm {...formProps}/> : false
     : false}
  </>
}
